export const TABLE_INFO = {
  ONPREM_LOWEST_SCORE: {
    HEADER_LABEL: {
      NAME: "Name",
      SCORE: "Score",
      MISCONFIGURATION: "Misconfig.",
    },
    PROPS: {
      NAME: "device_name",
      SCORE: "security_score",
      MISCONFIGURATION: "failed_count",
      VENDOR: "vendor",
      TYPE: "device_type",
      REGION: "region_name",
    },
  },
  ONPREM_LOWEST_CVE_SCORE: {
    HEADER_LABEL: {
      NAME: "Name",
      CVE_SCORE: "CVE Score",
      CVE_COUNT: "CVE's",
    },
    PROPS: {
      NAME: "device_name",
      CVE_SCORE: "cve_score",
      CVE_COUNT: "cve",
      VENDOR: "vendor",
      TYPE: "device_type",
      REGION: "region_name",
    },
  },
  ONPREM_LOWEST_COMPLIANCE: {
    HEADER_LABEL: {
      NAME: "Name",
      NIST: "NIST 800-53",
      CSC: "CIS 8",
    },
    PROPS: {
      NAME: "device_name",
      NIST: "NIST_800-53 r4",
      CSC: "CIS_8",
      VENDOR: "vendor",
      TYPE: "device_type",
      REGION: "region",
    },
  },
  CLOUD_LOWEST_SCORE: {
    HEADER_LABEL: {
      NAME: "Name",
      SCORE: "Score",
      MISCONFIGURATION: "Misconfig.",
    },
    PROPS: {
      NAME: "device_name",
      SCORE: "security_score",
      MISCONFIGURATION: "failed_count",
      VENDOR: "vendor",
      TYPE: "device_type",
      REGION: "region_name",
    },
  },
  CLOUD_LOWEST_COMPLIANCE: {
    HEADER_LABEL: {
      NAME: "Name",
      NIST: "NIST 800-53",
      CSC: "CIS 8",
    },
    PROPS: {
      NAME: "device_name",
      NIST: "NIST_800-53 r4",
      CSC: "CIS_8",
      VENDOR: "vendor",
      TYPE: "device_type",
      REGION: "region",
    },
  },
  TOP_MISCONFIGURATIONS: {
    HEADER_LABEL: {
      NAME: "Name",
      SEVERITY: "Severity",
      ASSETS: "Asset",
      RESOURCES: "Resource",
    },
    PROPS: {
      COUNT: "count",
      PARAMETER: "parameter",
      FAILED_COUNT: "failed_count",
      VULNERABILITY: "vulnerability",
      DEVICE: "device",
    },
  },
  TOP_CVES: {
    HEADER_LABEL: {
      CVE_ID: "CVE",
      CVSS: "CVSS",
      SEVERITY: "Severity",
      CISSA_KEV: "CISA's KEV",
      EPSS: "EPSS",
      ASSETS: "Assets",
    },
    PROPS: {
      CVE_ID: "cve_id",
      CVSS: "score",
      SEVERITY: "severity",
      CISSA_KEV: "cisas_kev",
      EPSS: "epss",
      ASSETS: "asset_count",
    },
  },
  RECENT_TICKETS: {
    HEADER_LABEL: {
      NAME: "Name",
      ISSUE_ID: "Issue ID",
      SUMMARY: "Summary",
      STATUS: "Status",
      PRIORITY: "Priority",
    },
    PROPS: {
      NAME: "name",
      ISSUE_ID: "issue_id",
      SUMMARY: "summary",
      STATUS: "status",
      PRIORITY: "priority",
    },
  },
  JIRA_TICKETS: {
    HEADER_LABEL: {
      KEY: "Key",
      SUMMARY: "Summary",
      STATUS: "Status",
      PRIORITY: "Priority",
      CREATED: "Created",
    },
    PROPS: {
      KEY: "key",
      SUMMARY: "summary",
      STATUS: "status",
      PRIORITY: "priority",
      CREATED: "created",
    },
  },
};
